
import AppSaleDetailBrowse from "@/components/sales/SaleDetailBrowse.vue";
import {Purchase} from "@/models/base";
import {View} from "@/models/view";
import Vue from "vue";
import {BookYearService, UserConfigService, ViewService} from "@/services";

export default Vue.extend({
	data(){
		return{
			selectedItems: [] as Purchase[],
			buttonDisabled: false,
			selectedBookYear: `${BookYearService.selectedBookYear}`,
			generalSettings: UserConfigService.getGeneralSettings(),
			view: null as View | null
		};
	},
	props: {
		multiple: {
			type: Boolean,
			default: false
		},
		overrideStaticViewSelect: Boolean,
		contactId: {
			type: Number,
			default: 0
		},
	},
	async mounted(){
		if(this.generalSettings.DefaultPurchaseDocumentRowF3Browse>0){
			this.view = await ViewService.getView(this.generalSettings.DefaultPurchaseDocumentRowF3Browse);
		}
	},
	components: {
		AppSaleDetailBrowse
	}
});
